import { AppConfig } from '@app/config/app.config';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export class AddHeaderInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
	  // Clone the request to add the new header

		let isLogin = req.url.indexOf('security/token') > -1;
		let clonedRequest = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });

		if (isLogin === false && AppConfig.accessToken !== undefined) {
            clonedRequest = clonedRequest.clone({ headers: req.headers.set('Authorization', 'bearer ' + AppConfig.accessToken) });
		}

		return next.handle(clonedRequest);
	}
}